import { Box, Typography } from "@mui/material";
import { InitialNameAvatar } from "../../../../components/images/initial-name-avatar";
import { CustomizedTable } from "../../../../components/mui/table/custom-table";
import { CONST_PROJECT_ARCHIVE_REASON, CONST_REJECT_OR_CANCEL_STATUSES } from "../../../../constants/lists";
import {
  ENUM_PROJECT_ARCHIVE_REASON,
  ENUM_PROJECT_STATUS,
  RENDERER_TYPES,
} from "../../../../enums";
import {
  DATE_FORMATS,
  formatDate,
} from "../../../../services/date-and-time.utils";
import { convertToFullName } from "../../../../services/utils";
import { ProjectStatus } from "../../../invitations/components/project-status";

function AmbassadorWiseSlotDetailsListTable({
  rows,
  columns,
  archiveSecondaryStatus,
  rejectMessage,
}) {
  const handleTDRenderer = (row, column) => {
    switch (column.rendererType) {
      case RENDERER_TYPES.FULL_DATE:
        return (
          row[column.field] &&
          `${formatDate(row[column.field], DATE_FORMATS.fullDateWithTime)}`
        );
      case RENDERER_TYPES.MEETING_STATUS: {
        const status = row.invitationStatus || row.status;
        const archiveMessage =
          status === ENUM_PROJECT_STATUS.ARCHIVE && archiveSecondaryStatus
            ? CONST_PROJECT_ARCHIVE_REASON[
                ENUM_PROJECT_ARCHIVE_REASON[
                  archiveSecondaryStatus?.toUpperCase()
                ]
              ]
            : null;
        const showRejectMessage =
          rejectMessage && CONST_REJECT_OR_CANCEL_STATUSES.has(status);

        return (
          <Box>
            <ProjectStatus data={row} />
            {row.rescheduleReason && (
              <Typography
                fontSize={11}
                color="#6B7280"
                lineHeight={1.4}
                mt={0.5}
              >
                <Box component="span" fontWeight={600} color="#374151">
                  Reason:{" "}
                </Box>
                {row.rescheduleReason}
              </Typography>
            )}
            {archiveMessage && (
              <Typography
                fontSize={11}
                color="#6B7280"
                lineHeight={1.4}
                mt={0.5}
              >
                <Box component="span" fontWeight={600} color="#374151">
                  Reason:{" "}
                </Box>
                {archiveMessage}
              </Typography>
            )}
            {showRejectMessage && (
              <Typography
                fontSize={11}
                color="#6B7280"
                lineHeight={1.4}
                mt={0.5}
              >
                <Box component="span" fontWeight={600} color="#374151">
                  Message:{" "}
                </Box>
                {rejectMessage}
              </Typography>
            )}
          </Box>
        );
      }
      case RENDERER_TYPES.FULL_NAME: {
        const actionPerformBy = row.actionPerformBy;
        if (!actionPerformBy) return null;

        return (
          <InitialNameAvatar
            text={convertToFullName(
              actionPerformBy.firstName,
              actionPerformBy.lastName
            )}
            name={actionPerformBy.firstName}
          />
        );
      }
      default:
        break;
    }
  };

  return (
    <CustomizedTable
      scrollable
      tdRenderer={handleTDRenderer}
      rows={rows}
      columns={columns}
    ></CustomizedTable>
  );
}

export { AmbassadorWiseSlotDetailsListTable };
